module.exports = __webpack_public_path__ + "img/fa-brands-400.1c61791.svg";